import { render, staticRenderFns } from "./NxReportHeader.vue?vue&type=template&id=449a3cc0&scoped=true"
import script from "./NxReportHeader.vue?vue&type=script&lang=js"
export * from "./NxReportHeader.vue?vue&type=script&lang=js"
import style0 from "./NxReportHeader.vue?vue&type=style&index=0&id=449a3cc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a3cc0",
  null
  
)

export default component.exports